export const isProductionHost = (url: string): boolean => {
  try {
    return new URL(url).host === 'miro.com'
  } catch {
    return false
  }
}
